import { nsMerchantUser } from '@/app/i18n/namespaces';

const MERCHANT_USER_STATUS = {
    ACTIVE: { name: 'ACTIVE', entity: 'status.ACTIVE', namespace: nsMerchantUser, variant: 'green' },
    INACTIVE: {
        name: 'INACTIVE', entity: 'status.INACTIVE', namespace: nsMerchantUser, variant: 'red'
    }
};

export default MERCHANT_USER_STATUS;